// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ukIh","largestCol":"styles_largestCol__3RyyL","smallestCol":"styles_smallestCol__3wPom"};